import { z } from "zod";
import { APIGame } from "@rosette/ts/src/business/api/api_schema.js";
import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";


export const ListGamesRequest = z.object({
    userPublicID: z.string(),
    fromGamePublicID: z.ostring(),
    limit: z.number(),
});
export type ListGamesRequest = z.infer<typeof ListGamesRequest>;


export const ListGamesResponse = z.object({
    userPublicID: z.string(),
    games: z.array(APIGame),
    endOfGames: z.boolean(),
});
export type ListGamesResponse = z.infer<typeof ListGamesResponse>;


export async function listGames(
    userPublicID: string,
    fromGamePublicID: string | null,
    limit: number,
): Promise<ListGamesResponse> {
    const request: ListGamesRequest = {
        userPublicID,
        fromGamePublicID: fromGamePublicID ?? undefined,
        limit,
    };
    const response = await fetchWithThrow("/api/listGames", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    return ListGamesResponse.parse(await response.json());
}
